import { SaasEndpoint } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { FlexApiUri } from './uri';

export class FlexApi {
  public static async validateApiToken(
    refreshToken: string,
    licenseKey: string
  ) {
    const body = {
      refreshToken,
      licenseKeys: [licenseKey]
    };
    const res = await Http.post<SaasEndpoint>(
      FlexApiUri.VALIDATE_API_TOKEN_URL,
      body
    );
    return res.data;
  }

  public static async onSaasEndpointIntegration(
    endpoint: SaasEndpoint,
    mask: boolean
  ) {
    const endpointDetails = {
      ...endpoint,
      mask: mask
    };
    const res = await Http.post(
      FlexApiUri.SAAS_ENDPOINT_INTEGRATION,
      endpointDetails
    );
    return res.data;
  }

  public static async saaSToOnpremMigrationDiscover
  (
    endpoint: SaasEndpoint,
    mask: boolean
  ) {
    const endpointDetails = {
      ...endpoint,
      mask: mask
    };
    const res = await Http.post(
      FlexApiUri.SAAS_ENDPOINT_INTEGRATION,
      endpointDetails
    );
    return res.data;
  }
}
